/**
 *
 * @Pattern https://mgechev.github.io/angularjs-in-patterns/#facade
 */

export default function BasketFixed(
    BasketFixedFactory,
    BasketFixedService,
    BasketFixedStorage
) {
    var fn = this;

    BasketFixedStorage.init();

    fn.getBookingId = function () {
        return BasketFixedStorage.getBookingIdStorage();
    };

    fn.setBookingId = function (bookingId) {
        return BasketFixedStorage.setBookingIdStorage(bookingId);
    };

    fn.deleteBookingId = function () {
        return BasketFixedStorage.deleteBookingId();
    };

    fn.getBookingActivity = function () {
        return BasketFixedStorage.getBookingActivity();
    };

    fn.getBookingLocation = function () {
        return BasketFixedStorage.getBookingLocation();
    };

    fn.getBookings = function () {
        return BasketFixedStorage.getBookings();
    };

    fn.resetBasketFixed = function () {
        fn.currentBookings = null;
        fn.activity = null;
        fn.location = null;
        BasketFixedStorage.resetBasketFixedStorage();
        fn.init();
    };

    fn.getSearchPeriodsUrl = function () {
        return BasketFixedStorage.getSearchPeriodsUrl();
    };

    fn.setSearchPeriodsUrl = function (url) {
        return BasketFixedStorage.setSearchPeriodsUrl(url);
    };

    /**
     *
     * factory functions
     */
    fn.addPeriod = function (lane, period) {
        return BasketFixedFactory.addPeriod(lane, period);
    };

    fn.removePeriod = function (period) {
        return BasketFixedFactory.removePeriod(period);
    };

    return fn;
}
